/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Text, Theme, useTheme } from 'bold-ui'
import { usePecField } from 'components/form'
import { ConfirmChangeRadioFieldContainer } from 'components/form/field/ConfirmChangeRadioFieldContainer'
import { useFlags } from 'config/useFlagsContext'
import { Fragment } from 'react'
import { MetaPath } from 'util/metaPath'
import { CondutaGroupEnum, CondutaGroupRecord } from 'view/cuidados-compartilhados/model-cuidadoCompartilhado'

import { OnCondutaGroupChangeCallback } from '../../discussao-caso/DiscussaoCasoFieldGroup'

interface CondutaGroupCuidadoCompartilhadoRadioFieldContainerProps<T> {
  name: MetaPath<T>
  pathCondutaGroup: MetaPath<CondutaGroupEnum>
  children: React.ReactNode
  value: CondutaGroupEnum
  isRadioHidden?: boolean
  onAskUserConfirmation: OnCondutaGroupChangeCallback
}

export function CondutaGroupCuidadoCompartilhadoRadioFieldContainer<T>(
  props: Readonly<CondutaGroupCuidadoCompartilhadoRadioFieldContainerProps<T>>
) {
  const { pathCondutaGroup, children, value, isRadioHidden, onAskUserConfirmation } = props

  const { PILOTO_VINCULACAO_CUIDADO_ENABLED } = useFlags()
  const theme = useTheme()
  const styles = createStyles(theme)

  const {
    input: { value: currentConduta },
  } = usePecField({
    name: pathCondutaGroup,
    subscription: { value: true },
  })

  const isSelected = currentConduta === value
  const { label } = CondutaGroupRecord[value]

  return (
    <Fragment>
      <ConfirmChangeRadioFieldContainer<CondutaGroupEnum>
        name={pathCondutaGroup.absolutePath()}
        value={value}
        style={styles.radioFieldContainer}
        isRadioHidden={isRadioHidden}
        onAskUserConfirmation={PILOTO_VINCULACAO_CUIDADO_ENABLED ? onAskUserConfirmation : null}
      >
        <Text fontWeight='bold'>{label}</Text>
      </ConfirmChangeRadioFieldContainer>

      {isSelected && <div css={styles.paper}>{children}</div>}
    </Fragment>
  )
}

const createStyles = (theme: Theme) => ({
  radioFieldContainer: css`
    background-color: ${theme.pallete.gray.c90};
  `,
  paper: css`
    padding: 1rem;
    border: 1px solid ${theme.pallete.gray.c60};
    border-radius: 0 0 2px 2px;
    margin-top: -1px;
  `,
})
